import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputForm
                        label="Notificação"
                        value={filters.title}
                        onChange={({target}) => setFilters(prev => ({ ...prev, title: target.value }))}
                        instanceId="title"
                        id="title"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <InputForm
                        label="ID da câmera"
                        value={filters.cameraId}
                        onChange={({target}) => setFilters(prev => ({ ...prev, cameraId: target.value }))}
                        instanceId="cameraId"
                        id="cameraId"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <div>
                        <SelectComponent
                            label='Assinadas'
                            isMulti={false}
                            options={[
                                {label: "Todas", value: 'all'},
                                {label: "Sim", value: 'true'},
                                {label: "Não", value: 'false'}
                            ]}
                            value={filters.sign}
                            onChange={(value) => setFilters(prev => ({...prev, sign: value}))}
                            instanceId="sign"
                            classNameWrapper={"w-full"}
                            isClearable={false}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;